import apiConfig from './config';

const getDni = (dni, success, error) => {
  return fetch(`${apiConfig.constants.URL_CUENTA_CONTASISCORP}/api/reniec-dni/${dni}`, {
    headers: {
      Accept: 'application/json',
    },
  })
    .then(apiConfig.methods.checkStatus)
    .then(apiConfig.methods.parseJSON)
    .then(success)
    .catch(apiConfig.methods.error)
    .then(error);
};

const exportedObject = {
  getDni,
};

export default exportedObject;
